const article = {
    slug: "pleats-please-issey-miyake",
    category: "BRAND BUYBACK",
    listTitle: "プリーツプリーズ買取",
    listDescription:
      "製品プリーツ、年代、柄、プリーツ状態、ISSEY MIYAKEの思想まで見て査定するEnclopediaのブランド別買取ページ。",
    seo: {
      title:
        "プリーツプリーズ買取｜PLEATS PLEASE ISSEY MIYAKEをアーカイブ価値まで査定買取",
      description:
        "PLEATS PLEASE ISSEY MIYAKE（プリーツプリーズ）の買取ならEnclopediaへ。製品プリーツ、年代、柄、プリーツ状態、ISSEY MIYAKEの思想やアーカイブ価値まで見て査定します。LINE事前査定から宅配買取へご案内します。",
      keyword:
        "プリーツプリーズ 買取,PLEATS PLEASE 買取,PLEATS PLEASE ISSEY MIYAKE 買取,プリーツプリーズ イッセイミヤケ 買取,イッセイミヤケ 買取,ISSEY MIYAKE 買取,三宅一生 買取,プリーツプリーズ 高価買取,プリーツプリーズ 宅配買取,プリーツプリーズ ワンピース 買取,プリーツプリーズ カーディガン 買取,プリーツプリーズ パンツ 買取,プリーツプリーズ トップス 買取,プリーツプリーズ セットアップ 買取,プリーツプリーズ アーカイブ,製品プリーツ,イッセイミヤケ アーカイブ買取,enclopedia,アンクロペディア",
      canonicalPath: "/brand_buyback/pleats-please-issey-miyake",
    },
    hero: {
      label: "PLEATS PLEASE ISSEY MIYAKE BUYBACK",
      number: "02 / BUYBACK",
      titleLines: [
        "プリーツプリーズ買取。",
        "製品プリーツの価値まで見て査定します。",
      ],
      body:
        "Enclopediaは、PLEATS PLEASE ISSEY MIYAKEを“プリーツの服”としてだけでは見ません。\n三宅一生が考えた、軽く、洗えて、動きやすく、身体に合わせて変化する服。\nその思想、製品プリーツの技術、年代、柄、状態、現在の需要まで確認し、アイテム単位で査定します。\nまずはLINEで写真をお送りください。宅配買取へ進む前に、事前に査定可否をご案内します。",
      primaryCtaLabel: "LINEで事前査定する",
      primaryCtaHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryCtaLabel: "宅配買取を申し込む",
      secondaryCtaHref: "https://www.enclopedia-official.com/kaitori/takuhai",
      keywords: [
        "pleats please buyback",
        "garment pleating",
        "issey miyake archive",
        "プリーツプリーズ買取",
      ],
      visualLabel: "ARCHIVE VALUATION",
      visualTitle: ["プリーツの状態だけでなく、", "服の思想まで見る。"],
      image: "media/archive_fashion/buyback_pleats_please.png",
      imageAlt: "PLEATS PLEASE ISSEY MIYAKE プリーツプリーズ買取のメイン画像",
    },
    thesis: {
      text:
        "PLEATS PLEASEは、装飾としてのプリーツではなく、身体・生活・技術をつなぐアーカイブとして査定する。",
      keywords: ["pleats", "garment pleating", "archive value"],
    },
    intro: {
      label: "02 / OUR BUYBACK VIEW",
      titleLines: [
        "プリーツプリーズの価値は、",
        "“プリーツがある服”だけでは測れない。",
      ],
      body:
        "PLEATS PLEASE ISSEY MIYAKEは、軽さ、伸縮性、洗える扱いやすさ、畳める利便性を持つ日常着でありながら、三宅一生の服作りの思想と技術が凝縮されたラインです。\n\nそのためEnclopediaでは、単にブランド名や中古相場だけで判断しません。\nどの年代のアイテムか、柄や色に需要があるか、プリーツの伸びや潰れがどの程度か、ワンピース・トップス・パンツ・セットアップとしての使いやすさはどうか。\n\nさらに、ISSEY MIYAKEのアーカイブ全体の中で、その一着がどのような価値を持つのかまで確認します。",
    },
    valuation: {
      label: "03 / WHAT WE VALUE",
      titleLines: ["Enclopediaが重視する、", "4つの査定視点。"],
      items: [
        {
          number: "01",
          title: "製品プリーツの状態を見る",
          text:
            "PLEATS PLEASEの価値は、プリーツの美しさと状態に大きく関わります。プリーツの伸び、潰れ、型崩れ、保管跡、洗濯による変化を確認します。",
        },
        {
          number: "02",
          title: "柄・色・シリーズの需要を見る",
          text:
            "無地、総柄、グラフィック、限定色、シーズン性の強いデザインなど、現在の需要と再入手難度を見ながら個別に査定します。",
        },
        {
          number: "03",
          title: "アイテムとしての使いやすさを見る",
          text:
            "ワンピース、カーディガン、トップス、パンツ、スカート、セットアップなど、レンタルや再流通での着用価値を確認します。",
        },
        {
          number: "04",
          title: "ISSEY MIYAKEの文脈を見る",
          text:
            "PLEATS PLEASEは、単なる便利な服ではありません。三宅一生の“多くの人のための服”という思想と技術を背景に持つラインとして評価します。",
        },
      ],
    },
    targetLines: {
      label: "04 / TARGET ITEMS",
      titleLines: ["PLEATS PLEASEを中心に、", "ISSEY MIYAKE系ラインも査定します。"],
      items: [
        {
          tag: "ITEM 01",
          title: "PLEATS PLEASE ISSEY MIYAKE",
          text:
            "ワンピース、トップス、カーディガン、パンツ、スカート、セットアップ、総柄アイテムまで幅広く査定します。",
        },
        {
          tag: "ITEM 02",
          title: "ISSEY MIYAKE",
          text:
            "コレクションラインのプリーツ、構造的なジャケット、ドレス、コート、アーカイブ性の高いアイテムも対象です。",
        },
        {
          tag: "ITEM 03",
          title: "HOMME PLISSÉ ISSEY MIYAKE",
          text:
            "メンズのプリーツラインも査定対象です。ジャケット、パンツ、セットアップ、コートなど、状態と需要を見て評価します。",
        },
        {
          tag: "ITEM 04",
          title: "me ISSEY MIYAKE",
          text:
            "日常性の高いストレッチプリーツやトップス類も内容に応じて査定します。状態・柄・需要を確認します。",
        },
        {
          tag: "ITEM 05",
          title: "A-POC / その他ISSEY MIYAKE関連ライン",
          text:
            "A-POC、132 5. ISSEY MIYAKEなど、三宅一生の技術や思想に関わるラインもご相談いただけます。",
        },
      ],
    },
    highValueItems: {
      label: "05 / HIGH VALUE ITEMS",
      titleLines: ["高価買取につながりやすい、", "プリーツプリーズ。"],
      intro:
        "査定額は状態や市場性で変動しますが、Enclopediaでは特に以下のようなPLEATS PLEASEを丁寧に見ます。",
      items: [
        {
          index: "01",
          title: "ワンピース・セットアップ",
          text:
            "PLEATS PLEASEの中でも、着用イメージが作りやすく需要の高いワンピースやセットアップは評価対象です。色、柄、丈、サイズ感を確認します。",
        },
        {
          index: "02",
          title: "総柄・グラフィック・シーズン性の強いアイテム",
          text:
            "無地だけでなく、柄やグラフィックが強いアイテムは視覚的な魅力があり、アーカイブとしても評価しやすい領域です。",
        },
        {
          index: "03",
          title: "状態の良い定番アイテム",
          text:
            "ブラック、ネイビー、グレー、ベージュなど使いやすい色のトップス、パンツ、カーディガンも、状態が良ければ安定した需要があります。",
        },
        {
          index: "04",
          title: "初期・旧タグ・希少カラー",
          text:
            "古い年代のアイテムは状態により評価が分かれますが、旧タグ、希少カラー、流通量の少ない柄は個別に確認します。",
        },
        {
          index: "05",
          title: "レンタルで体験価値が高い服",
          text:
            "Enclopediaでは買取後にレンタル・共有する視点もあります。写真だけでは伝わりにくい軽さや動きがあるアイテムは、次の着用者へつなげやすい価値があります。",
        },
      ],
    },
    quote: {
      textLines: [
        "プリーツは、装飾ではなく技術。",
        "そして、日常を自由にするための設計です。",
      ],
    },
    assessmentDifference: {
      label: "06 / ASSESSMENT DIFFERENCE",
      titleLines: ["一般的な査定で、", "見落とされやすい価値。"],
      intro:
        "Enclopediaは、ブランド古着としての流通性だけでなく、PLEATS PLEASEが持つ技術・身体性・日常性まで確認します。",
      items: [
        {
          index: "01",
          title: "“プリーツ服”として一括りにしない",
          text:
            "PLEATS PLEASEは、単なるプリーツ加工の服ではありません。縫製後にプリーツをかける製品プリーツの技術と、生活で使える機能性を評価します。",
        },
        {
          index: "02",
          title: "プリーツの状態を細かく見る",
          text:
            "伸び、潰れ、型崩れ、汚れ、保管跡、裾や袖口の状態など、着用時の見え方に影響する部分を確認します。",
        },
        {
          index: "03",
          title: "柄や色の需要を見落とさない",
          text:
            "PLEATS PLEASEは、同じ形でも色や柄で需要が大きく変わります。市場相場だけでなく、現在の着用ニーズも見ます。",
        },
        {
          index: "04",
          title: "売れるかだけでなく、体験される価値を見る",
          text:
            "Enclopediaはアーカイブをレンタル・共有するサービスでもあります。軽さ、伸縮性、動きやすさなど、次の着用者が体験できる価値も見ます。",
        },
      ],
    },
    buybackPoints: {
      label: "07 / CHECK POINTS",
      titleLines: ["査定前に確認したい、", "プリーツプリーズの状態。"],
      items: [
        {
          index: "01",
          title: "プリーツの伸び・潰れ",
          text:
            "保管方法や着用頻度によって、プリーツが伸びたり潰れたりする場合があります。全体写真と近接写真があると確認しやすくなります。",
        },
        {
          index: "02",
          title: "汚れ・引っかけ・毛羽立ち",
          text:
            "白や淡色は汚れ、濃色は擦れや毛羽立ちが目立つ場合があります。気になる箇所も隠さず撮影してください。",
        },
        {
          index: "03",
          title: "タグ・品番・サイズ表記",
          text:
            "ブランドタグ、品質タグ、品番、サイズ表記は査定に重要です。タグ写真があると年代やラインの確認がしやすくなります。",
        },
        {
          index: "04",
          title: "セットアップの有無",
          text:
            "トップスとパンツ、ジャケットとスカートなど、セットで揃っている場合は評価が変わることがあります。",
        },
      ],
    },
    flow: {
      label: "08 / BUYBACK FLOW",
      titleLines: ["LINE事前査定から、", "宅配買取へ。"],
      items: [
        {
          step: "STEP 01",
          title: "LINEで事前査定",
          text:
            "全体写真、タグ写真、プリーツ状態、汚れや傷の写真をお送りください。宅配買取へ進む前に、おおまかな査定可否をご案内します。",
        },
        {
          step: "STEP 02",
          title: "宅配買取を申込",
          text:
            "本査定をご希望の場合は申込フォームへ。宅配キットの要否もここで選択できます。",
        },
        {
          step: "STEP 03",
          title: "無料で発送",
          text:
            "送料は無料。ご自身の箱または選択制の宅配キットで商品をお送りください。",
        },
        {
          step: "STEP 04",
          title: "本査定・ご入金",
          text:
            "到着後に状態・真贋・プリーツの状態・現在の需要を確認。金額にご納得いただければご指定口座へ入金します。",
        },
      ],
    },
    assurance: {
      label: "09 / SAFE BUYBACK",
      titleLines: ["相談しやすく、", "進めやすい宅配買取。"],
      intro:
        "LINEで相談してから進められるため、買取成立までの不安と手間を減らせます。",
      items: [
        {
          title: "LINE事前査定あり",
          text:
            "まず写真で相談してから進められるため、無駄な発送や手間を減らせます。",
        },
        {
          title: "送料は無料",
          text:
            "宅配買取の発送費用はEnclopediaが負担します。",
        },
        {
          title: "宅配キットは選択制",
          text:
            "必要な方には宅配キットをご用意。ご自身で梱包できる場合はそのまま発送可能です。",
        },
        {
          title: "キャンセル返送料は基本無料",
          text:
            "査定金額にご納得いただけない場合の返送も基本無料です。",
        },
      ],
      notice:
        "キャンセル返送料は基本無料です。ただし、お送りいただいた品がすべてコピー品、または真贋判定不可品のみだった場合は、返送料をご負担いただく場合があります。",
    },
    faq: {
      label: "10 / FAQ",
      titleLines: ["プリーツプリーズ買取で、", "よくあるご質問。"],
      items: [
        {
          question: "PLEATS PLEASE ISSEY MIYAKEの買取はできますか？",
          answer:
            "可能です。PLEATS PLEASE ISSEY MIYAKEのワンピース、トップス、カーディガン、パンツ、スカート、セットアップ、総柄アイテムまで幅広く査定します。",
        },
        {
          question: "プリーツが少し伸びていても査定できますか？",
          answer:
            "査定可能です。ただし、プリーツの伸びや潰れ、型崩れは査定額に影響します。全体写真と近接写真をLINEでお送りいただくと確認しやすくなります。",
        },
        {
          question: "古いプリーツプリーズでも買取できますか？",
          answer:
            "古い年代のアイテムも査定できます。旧タグ、希少カラー、総柄、状態の良いものは個別に評価します。ただし、年代だけで一律に高くなるわけではなく、状態や現在の需要も確認します。",
        },
        {
          question: "どんなアイテムが高価買取になりやすいですか？",
          answer:
            "ワンピース、セットアップ、人気色、総柄、グラフィック性の強いアイテム、状態の良い定番品は評価しやすい傾向があります。プリーツの状態や汚れの有無も重要です。",
        },
        {
          question: "ISSEY MIYAKEやHOMME PLISSÉも買取できますか？",
          answer:
            "可能です。PLEATS PLEASEだけでなく、ISSEY MIYAKE、HOMME PLISSÉ ISSEY MIYAKE、me ISSEY MIYAKE、A-POCなども内容に応じて査定します。",
        },
        {
          question: "LINE査定では何を送ればいいですか？",
          answer:
            "全体写真、ブランドタグ、品質タグ、品番、サイズ表記、プリーツの状態、汚れやダメージ箇所の写真をお送りください。セットアップの場合は上下まとめて撮影してください。",
        },
        {
          question: "キャンセルした場合、返送料はかかりますか？",
          answer:
            "基本的には無料です。ただし、お送りいただいた品がすべてコピー品、または真贋判定不可品のみだった場合は、返送料をご負担いただく場合があります。",
        },
      ],
    },
    finalCta: {
      titleLines: [
        "まずはLINEで、",
        "プリーツプリーズの価値をご相談ください。",
      ],
      body:
        "PLEATS PLEASE ISSEY MIYAKEは、軽く、洗えて、動きやすい日常着でありながら、三宅一生の技術と思想を残すアーカイブでもあります。\n宅配買取へ進む前に、写真で事前確認。\n製品プリーツの状態、柄、年代、現在の需要まで見て、Enclopediaが丁寧に査定します。",
      primaryLabel: "LINEで事前査定する",
      primaryHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryLabel: "宅配買取を申し込む",
      secondaryHref: "https://www.enclopedia-official.com/kaitori/takuhai",
    },
  };
  
  export default article;